import { FC } from 'react'
import DialogUploadWizard from './DialogUploadWizard'

export type { DialogUploadProps } from './types'

import type { DialogUploadProps } from './types'

/** Modale de création de dossier (wizard). */
export const DialogUpload: FC<DialogUploadProps> = (props) => (
  <DialogUploadWizard {...props} />
)

export default DialogUpload
